import { Box, Typography } from '@mui/material';
import { t } from 'i18next';

const LABEL_COLOR = '#1565c0';

const EcgToolbar = ({ ecgTimeWindow }) => {
    const hasWindow = ecgTimeWindow?.startIso && ecgTimeWindow?.endIso;

    if (!hasWindow) return null;

    return (
        <Box display="flex" justifyContent="center" alignItems="center" mb={1}>
            <Typography
                variant="h5"
                sx={{
                    color: 'text.secondary',
                    display: 'flex',
                    alignItems: 'center',
                    gap: 1,
                    flexWrap: 'wrap'
                }}
            >
                <Typography
                    component="span"
                    sx={{
                        color: LABEL_COLOR,
                        fontWeight: 600
                    }}
                >
                    {t('ECG.start')}
                </Typography>

                <Typography component="span" sx={{ fontWeight: 500 }}>
                    {ecgTimeWindow.startIso}
                </Typography>

                <Typography component="span" sx={{ mx: 1 }}>
                    /
                </Typography>

                <Typography
                    component="span"
                    sx={{
                        color: LABEL_COLOR,
                        fontWeight: 600
                    }}
                >
                    {t('ECG.end')}
                </Typography>

                <Typography component="span" sx={{ fontWeight: 500 }}>
                    {ecgTimeWindow.endIso}
                </Typography>
            </Typography>
        </Box>
    );
};

export default EcgToolbar;
